import styled from 'styled-components';

export const FooterBar = styled.footer`
  font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif ' : 'DINRegular ')};
  margin: 50px 0 0;
  display: flex;
  color: #fff;
  text-transform: uppercase;

  @media (max-width: 1199px) {
    flex-flow: column;
  }

  @media (max-width: 767.98px) {
    margin-top: 30px;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;

    li {
      padding: 0;
      line-height: 1.96;
    }
  }

  a {
    color: #fff;
  }
`;

export const FooterLinksContainer = styled.div`
  &.content {
    background-color: #333;

    @media (min-width: 1200px) {
      padding: ${({ dir }) => (dir === 'rtl' ? '0 5% 0 3.5%;' : '0 3.5% 0 5%')};
      width: 70%;
    }

    @media (max-width: 1199px) {
      padding: 0 30px;
      width: 100%;
    }
    @media (max-width: 575.98px) {
      padding: 40px 0;
    }
  }
`;

export const FooterLinks = styled.div`
  &.linking {
    max-width: 1000px;
    margin-left: ${({ dir }) => (dir === 'rtl' ? '' : 'auto')};
    margin-right: ${({ dir }) => (dir === 'rtl' ? 'auto' : '')};
  }
`;

export const LinkListSpan = styled.span`
  padding: 0;
  line-height: ${({ dir }) => (dir === 'rtl' ? '20px' : '1.96')};
  display: block;

  @media (max-width: 575.98px) {
    line-height: ${({ dir }) => (dir === 'rtl' ? '2' : '2')};
  }

  a {
    @media (max-width: 575.98px) {
      font-size: ${({ dir }) => (dir === 'rtl' ? '12px' : '12px')};
    }
  }
`;
